import { Opportunity } from '@chunker/chunker-request'
import { useFormikContext } from 'formik'
import { DeepPartial } from 'types/DeepPartial'

function useOpportunityFormRequirements() {
  const { values } = useFormikContext<
    DeepPartial<
      Opportunity & {
        warehouseSpaceNeededMin: number
        warehouseSpaceNeededMax: number
      }
    >
  >()

  const {
    warehouseCity,
    warehouseState,
    warehouseDateStart,
    warehouseMonthToMonth,
    warehouseDateEnd,
    warehouseSpaceNeededMin,
    warehouseSpaceNeededMax,
  } = values

  const warehouseCityPresent = Boolean(warehouseCity)
  const warehouseStatePresent = Boolean(warehouseState)
  const warehouseDateStartPresent = Boolean(warehouseDateStart)
  const warehouseDateEndPresent = Boolean(warehouseDateEnd)
  const warehouseSpaceNeededMinPresent = Boolean(warehouseSpaceNeededMin)
  const warehouseSpaceNeededMaxPresent = Boolean(warehouseSpaceNeededMax)
  const warehouseMonthToMonthPresent = Boolean(warehouseMonthToMonth)

  const requiredSet1 = [
    warehouseCityPresent,
    warehouseStatePresent,
    warehouseDateStartPresent,
    warehouseDateEndPresent,
    warehouseSpaceNeededMinPresent || warehouseSpaceNeededMaxPresent,
  ]

  const requiredSet2 = [
    warehouseCityPresent,
    warehouseStatePresent,
    warehouseDateStartPresent,
    warehouseSpaceNeededMinPresent || warehouseSpaceNeededMaxPresent,
    warehouseMonthToMonthPresent,
  ]

  const requirementsMet = warehouseMonthToMonth
    ? requiredSet2.every(Boolean)
    : requiredSet1.every(Boolean)

  return {
    requirementsMet,
    warehouseCityPresent,
    warehouseStatePresent,
    warehouseDateStartPresent,
    warehouseDateEndPresent,
    warehouseSpaceNeededMinPresent,
    warehouseSpaceNeededMaxPresent,
    warehouseMonthToMonthPresent,
  }
}

export default useOpportunityFormRequirements
